import { Component } from '@angular/core';

@Component({
  selector: 'dash-dashboard',
  imports: [],
  templateUrl: './dashboard.html',
  styleUrl: './dashboard.css'
})
export class Dashboard {

}
